export default {
  vWebsiteArticle: {
    listExternal: `/vWebsiteArticle/listExternal`,
    getExternal: `/vWebsiteArticleDetail/getExternal`,
    getBannerList: `/vWebsiteBanner/listExternal`,
    getResearchTeamList: `/websiteResearchTeam/listExternal`,
    getResearchTeamDetail: `/websiteResearchTeam/getExternal`,
    getTeacherList: `/websiteTeacherProfile/listExternal`,
    getTeacherDetail: `/websiteTeacherProfile/getExternal`,
    getTeacherMentorList: `/websiteTeacherProfile/mentorProfileExternal`,
    getStudentTeamDetail: `/websiteStudentTeam/getExternal`,
    getSharedInstrumentDetail: `/websiteSharedInstrument/getExternal`,
    getSharedInstrumentList: `/websiteSharedInstrument/listExternal`,
    getStudentTeamList: `/websiteStudentTeam/listExternal`,
  },
};
